import React from "react";
import Weather from "./Weather";
import "./App.css";

export default function App() {
  return (
    <div className="App">
      <div className="container">
        <Weather defaultCity="Czestochowa" />
      </div>
      <footer>
        This project was coded by Nataliia Vlasenko and it is {""}
        <a
          href="https://github.com/Nataliia84/react-weather"
          target="_blank"
          rel="noreferrer"
        >
          open-sourced on GitHub
        </a>{" "}
        and{" "}
        <a
          href="https://app.netlify.com/sites/genuine-selkie-df2fab"
          target="_blank"
          rel="noreferrer"
        >
          hosted on Netlify
        </a>
      </footer>
    </div>
  );
}
